import { compact, get } from 'lodash';
// tslint:disable
import * as React from 'react';
import { Subject } from 'rxjs/Subject';
import { Field } from '../libs/form.lib';
import { BaseField } from '../libs/input-base';
import { Validator } from '../libs/Validators';
import { IriPresenter } from '../structurals/presenters/iri-presenter';
import { ResourceModal } from '../structurals/resource-modal';
import './media-item.scss';

export interface InputFieldPropInterface {
    className?: string;
    title?: string;
    placeholder?: string;
    property?: string;
    validators?: Validator[];
    field: Field;
    type?: string;
    onChange?: (value: any) => void;
    hideThumbnail?: boolean
}

export class MediaItemField extends BaseField<InputFieldPropInterface> {
    public field: Field = this.props.field;
    public onChange$: Subject<any> = new Subject();
    public onCloseSignal: Subject<any> = new Subject();
    public state: any = {
        error: null,
        items: [],
        initialized: false
    };

    componentDidMount() {
        this.field.registerField();

        this.onChange$.subscribe((value: any) => {
            this.setState({
                items: value
            });
            if (this.field.multi) {
                this.field.setValue(value || [], false, false);
                if (this.props.onChange) {
                    this.props.onChange(value || []);
                }
            } else {
                if (value.length) {
                    this.field.setValue(value[0], false, false);
                    if (this.props.onChange) {
                        this.props.onChange(value[0]);
                    }
                }
            }
        });

        if (this.field.value && this.field.registered) {
            this.field.onValueChanges$.next(this.field.value);
        }

        this.field.onValueChanges$.subscribe((value) => {
            if (!value) {
                return;
            }

            if (this.field.multi) {
                this.onChange$.next((value || []).map((v: any) => get(v, '@id')));
            } else {
                this.onChange$.next([get(value, '@id')]);
            }
        });

        // abban az esetben, ha keson jonne meg a form es elsult volna az OnValueChange-s
        if (this.field.value) {
            this.field.onValueChanges$.next(this.field.value);
        }

        this.field.onValueChanges$.next(this.field.multi ? [] : null);
        this.setState({initialized: true});
    }

    public handleRawClick(url: any) {
        var a = document.createElement("a");
        a.target = "_blank";
        a.href = url;
        a.click();
    }
    removeItem(item: string) {
        const newItems = this.state.items.filter((i: any) => i !== item);
        this.onChange$.next(newItems);
        this.setState({
            items: newItems
        });
    }

    render() {
        return <div>
            <div className="form-group">
                <label>{this.field.title}</label>
                {!this.props.hideThumbnail && (!this.state.items || this.state.items.length == 0) &&
                <div className="thumbnail">
                    <div className="text-center">No image</div>
                </div>
                }
                {!this.props.hideThumbnail && compact(this.state.items).map((item: any, index: number) => <div key={index} className="item">
                    <div className="thumbnail">
                        <IriPresenter
                            iri={item}
                            path='images.original'
                            render={(src: any) => {
                                return (
                                    <div>
                                    <img src={src} className="img-fluid"/>
                                    <div className="buttons">
                                        <button className="btn btn-danger btn-sm" onClick={() => this.removeItem(item)}><i className="fa fa-fw fa-trash"/></button>
                                        &nbsp;
                                    <button className="btn warning btn-sm" onClick={() => this.handleRawClick(src)}><i className="fa fa-fw fa-link"/></button>
                                </div></div>)
                            }}/>

                    </div>
                </div>)}
                <div className="mrg10T">
                    {this.state.initialized && <ResourceModal title={(!this.state.items || this.state.items.length == 0) ? 'Select image(s)' : 'Modify image(s)'} onCloseSignal={this.onCloseSignal} entity="file-manager" config={{
                        defaultSelected: compact(this.state.items),
                        onSelectSuccessful: (event: any) => {
                            this.onChange$.next(event.map((i: any) => get(i, '@id')));
                            this.onCloseSignal.next(true);
                        },
                        multi: this.field.multi
                    }}/>}
                </div>
                <div className="divider"></div>
            </div>
        </div>;
    }
}



// WEBPACK FOOTER //
// ./src/components/fields/media-item.field.tsx